// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"P5-z","colorTextValue":"Q5-z","swatches":"R5-z","collapseLink":"S5-z","isCollapsed":"T5-z","dropdown":"U5-z","disabled":"V5-z"};